import { ProjectTemplatesState } from './types';

const initialState: ProjectTemplatesState = {
  list: [],
  isLoading: false,
  error: null,
};

export default initialState;
